import { AreaApi } from "../../api";
import { IStationRouteWaypointStationLike } from "../../models";

export const resolveWaypointAreaIdFromNeighbors = ({
  stations,
  insertAfterIndex,
}: {
  stations: IStationRouteWaypointStationLike[];
  insertAfterIndex: number;
}): number | undefined => {
  const beforeStation = stations[insertAfterIndex];
  const afterStation = stations[insertAfterIndex + 1];

  return beforeStation?.areaId ?? afterStation?.areaId;
};

export const resolveStationRouteWaypointAreaId = async ({
  latitude,
  longitude,
  stations,
  insertAfterIndex,
}: {
  latitude: number;
  longitude: number;
  stations: IStationRouteWaypointStationLike[];
  insertAfterIndex: number;
}): Promise<number | undefined> => {
  try {
    const areas = await AreaApi.findByCoordinates({
      lat: latitude,
      lng: longitude,
    });

    if (areas?.length && areas[0]?.id) {
      return areas[0].id;
    }
  } catch {
    // fall back to neighboring passenger stations
  }

  return resolveWaypointAreaIdFromNeighbors({ stations, insertAfterIndex });
};
